import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=78975b81&scoped=true"
import script from "./Wallet.vue?vue&type=script&setup=true&lang=js"
export * from "./Wallet.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=78975b81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78975b81",
  null
  
)

export default component.exports